module.exports = {
    test: {
        title: 'Multilingual switching test',
        btnTextOne: 'Chinese',
        btnTextTwo: 'English',
        btnTextThree: 'Korean',
        content: 'Be consistent with real life: be consistent with the process and logic of real life, and follow the language and concepts used by users; Consistent in the interface: all elements and structures should be consistent, such as design style, icon and text, element location, etc.',
    }
}